<template>
  <div class="auth-layout">
    <FLoader />
    <router-view />
    <MyDialog />
    <ConfirmDialog />
  </div>
</template>
<script>

export default {
  name: 'AuthLayout',
  components: {

  },

  data() {
    return {
  
    };
  },

  computed: {

  },

};
</script>